module.exports = __webpack_public_path__ + "img/front_logo.1739be65.png";